<div class="dialog-loading" *ngIf="(loading$ | async)">
  <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
  <div class="dialog-title">{{'modules.billing.counterParty.tariffDialog.title' | translate}}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>
<div class="dialog-content scrollable">
  <form [formGroup]="tariffForm" class="dialog-form scroll-content-padding df-c gap15" autocomplete="off">
    <div class="df gap20">
      <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 170px; min-width: 170px; max-width: 170px;">
        <mat-label>{{'modules.clients.associations.associationTariffDialog.labels.startDate' | translate}}</mat-label>
        <input matInput [matDatepicker]="startDate" formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="startDate">
        </mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
        <mat-label>{{'modules.clients.associations.associationTariffDialog.labels.tariff' | translate}}</mat-label>
        <mat-select class="select-panel" panelClass="dialog-select-panel" formControlName="tariff">
          <mat-option [value]="'FINANCES'">{{'modules.billing.counterParty.tariffs.FINANCES' | translate}}</mat-option>
          <mat-option [value]="'FINANCES_BENEFIT'">{{'modules.billing.counterParty.tariffs.FINANCES_BENEFIT' | translate}}</mat-option>
          <mat-option [value]="'SOCIAL'">{{'modules.billing.counterParty.tariffs.SOCIAL' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>

<div class="buttons-row df jc-e ai-c">
  <button class="default-button apply-button" [disabled]="tariffForm.invalid" (click)="submitForm()">
    {{'common.save' | translate}}
  </button>
</div>
